<template>
    <div class="container mt-5">
      <div class="flex-row-between border-bottom mb-4 pb-2">
        <h2 class="m-0 p-0">Pivot - {{dataName}}<small>(drag & drop UI + PivotTable)</small></h2>
      </div>
        <div class="mb-5">
          <pivot
            v-if="data"
            ref="pivotTable"
            :data="renderData"
            :dataProvider="dataProvider"
            :currentOperation="currentOperation"
            :currentCalcColumn="currentCalcColumn"
            :currentConditionGroup="currentConditionGroup"
            :saveCalcProp="saveCalcProp"
            :saveAsCalcPropertyDisabled="saveAsCalcPropertyDisabled"
            :calcColumns="calcColumns"
            :operations="operations"
            :sql="sql"
            :reload="reload"
            :csvData="csvData"
            :loadMore="loadMore"
            :totalItems="totalItems"
            :numOfPage="numOfPage"
            :prevRow="prevRow"
            :nextRow="nextRow"
            :prevCol="prevCol"
            :nextCol="nextCol"
            :rowPage="rowPage"
            :rowPages="rowPages"
            :colPage="colPage"
            :colPages="colPages"
            :rowsPages="rowsPages"
            :rowsPerPage="rowsPerPage"
            :itemsPerPage="itemsPerPage"
            :isLoadMore="totalItems > 1000 && (rowFields.length !== 0 || colFields.length !== 0)"
            :fields="fields"
            :row-fields="rowFields"
            :col-fields="colFields"
            :showSettings="showSettings"
            :showSQLSettings="showSQLSettings"
            :showFilterSettings="showFilterSettings"
            :highlightAsHeatmap="highlightAsHeatmap"
            @changeSQLQuery="changeSQLQuery"
            @changeShowSetting="changeShowSetting"
            @changeShowSQLSettings="changeShowSQLSettings"
            @changeShowFilterSetting="changeShowFilterSetting"
            @changeHighlightAsHeatmap="changeHighlightAsHeatmap"
            @changeCurrentOperation="changeCurrentOperation"
            @changeCurrentCalcColumn="changeCurrentCalcColumn"
            @changeCurrentConditionGroup="changeCurrentConditionGroup"
            >
          </pivot>
        </div>
        <br />
        <!-- <div v-if="totalItems < 1000 && rowPage !== rowPages">
          <span>Rows: </span>
          <span class="controll" v-on:click="prevRow"><</span>
          <span>{{ rowPage }} / {{ rowPages }}</span>
          <span class="controll" v-on:click="nextRow">></span>
        </div>
        <div v-if="totalItems < 1000 && colPage !== colPages">
          <span>Cols: </span>&nbsp;
          <span class="controll" v-on:click="prevCol"><</span>
          <span>{{ colPage }} / {{ colPages }}</span>
          <span class="controll" v-on:click="nextCol">></span>
        </div>
      </div> -->
      <div v-if="rowPage !== rowPages">
          <span>Rows: </span>
          <span class="controll" v-on:click="prevRow"><</span>
          <span>{{ rowPage }} / {{ rowPages }}</span>
          <span class="controll" v-on:click="nextRow">></span>
        </div>
        <div v-if="colPage !== colPages">
          <span>Cols: </span>&nbsp;
          <span class="controll" v-on:click="prevCol"><</span>
          <span>{{ colPage }} / {{ colPages }}</span>
          <span class="controll" v-on:click="nextCol">></span>
        </div>
      </div>
</template>

<script>
import Pivot from './Pivot';
import { mapState } from 'vuex';
import { getPivot } from '@/helpers/pivot';
import { paginateArray, paginateMatrix } from '@/helpers/paginateArray';
import db from '@/services/db'

export default {
  name: 'pivot-all',
  props: {
    options: {
      type: Object,
    },
    dataProvider: {
      type: String,
    },
    dataName: {
      type: String
    }
  },
  components: {
    Pivot
  },
  data: () => {
    return {
      sql: null,
      data: [],
      csvData: [],
      fields: null,
      rowFields: null,
      colFields: null,
      rowPage: null,
      rowPages: null,
      colPage: null,
      colPages: null,
      showPagination: null,
      showSettings: null,
      showSQLSettings: null,
      showFilterSettings: null,
      highlightAsHeatmap: null,
      calcColumns: [],
      currentCalcColumn: null,
      currentOperation: null,
      currentConditionGroup: null,
      operations: [],
      rowsPerPage: [],
      rowsPages: null,
      numOfPage: null,
      totalItems: null,
      itemsPerPage: null,
      computedItems: [],
      oldSql: '',
    }
  },
  mounted () {
    if (this.dataProvider) {
      // get & set number of rows that we have for this pivot table
      const savedNumOfItemsPerPage = parseInt(localStorage.getItem(window.location.pathname))
      const totalItems = $getGrid(this.dataProvider).length;
      this.totalItems = totalItems;
      this.numOfPage = 1;
      this.itemsPerPage = totalItems;

      // if (totalItems > 1000) {
      //   this.itemsPerPage = savedNumOfItemsPerPage ? savedNumOfItemsPerPage : 100;
      // } else {
      //   this.itemsPerPage = savedNumOfItemsPerPage ? savedNumOfItemsPerPage : totalItems;
      // }

      this.loadData(this.dataProvider, this.options, this.itemsPerPage);

      // create dataset for pagination select depending on number of items(rows) that we get
      let hundreds = [];
      let dozens = [];
      let thousends = [];

      if (totalItems > 1000) {
        dozens = [10, 20, 30, 40, 50, 60, 70, 80, 90];
        hundreds = [100, 200, 300, 400, 500, 600, 700, 800, 900];
        for(let i = 0; i<=Math.round(totalItems/1000); i++) {
          i !== 0 ? thousends.push(i*1000) : null;
        }
        if(!Number.isInteger(totalItems/1000)) {
          const numOfIterations = parseInt(String(totalItems % 1000).charAt(0));
          for(let i = 0; i<=numOfIterations; i++) {
            if(i !== 0) {
              let newVal = thousends[thousends.length - i] + (i*100);
              thousends.push(newVal);
            }
          }
        }
      } else if(totalItems > 100) {
        dozens = [10, 20, 30, 40, 50, 60, 70, 80, 90];
        for(let i = 0; i<=Math.round(totalItems/100); i++) {
          i !== 0 ? hundreds.push(i*100) : null;
        }
      } else {
        for(let i = 0; i<=Math.round(totalItems/10); i++) {
          i !== 0 ? dozens.push(i*10) : null;
        }
      }

      this.rowsPerPage = [...dozens, ...hundreds, ...thousends];
    }

    setTimeout(() => {
      const onChanged = _.debounce((cur, prev) => {
        if (prev) {
          this.emitChangedOptions();
        }
      }, 200);

      const checker = (prop) => () => this.getPivotInternalDataByProp(prop);
      this.$watch(checker('rowFields'), (cur, prev) => onChanged(cur, prev));
      this.$watch(checker('colFields'), (cur, prev) => onChanged(cur, prev));
    });
  },
  computed: {
    isSqlChanged() {
      return this.currentCaclPropVal === this.createCalcPropMethod(this.sql, this.dataProvider);
    },
    saveAsCalcPropertyDisabled() {
      return !(this.sql && this.dataProvider) || this.isSqlChanged;
    },
    calcPropExists() {
      return this.computedItems.includes(this.dataName)
    },
    renderData() {
      return this.paginate();
    },
    ...mapState([
      "dataGrid_options"
    ])
  },
  created () {
    this.getCalculatedPropertyKeys();
  },
  methods: {
    getCalculatedPropertyKeys() {
      db.computed.read((computed) => {
        if (computed !== undefined && computed !== null) {
          this.computedItems = Object.keys(computed)
          if(computed[this.dataName]) {
            this.currentCaclPropVal = computed[this.dataName];
          }
        }
      })
    },
    createCalcPropMethod(sql, tableName) {
      return `
          alasql.options.cache = false
          let res = alasql('${sql}', [$getGrid('${tableName}')] )
          return res
      `
    },
    updateCalcPropValue(key, value) {
      db.computed.update(key, value)
      this.$store.commit('editComputed', {
        key: this.dataProvider,
        insert: false
      });
      this.oldSql = this.sql;
      this.getCalculatedPropertyKeys()
    },

    saveCalcProp() {
      const calcPropFunc = this.createCalcPropMethod(this.sql, this.dataProvider);

      if(this.calcPropExists) {
        this.updateCalcPropValue(this.dataName, calcPropFunc);
      } else {
        db.computed.create(this.dataName, (v) => {
          this.$store.commit('editComputed', {
            key: this.dataName,
            insert: true
          })
          this.updateCalcPropValue(this.dataName, calcPropFunc);
        })
      }
    },
    loadMore() {
      this.numOfPage += 1
      const itemsPerPage = parseInt(this.itemsPerPage)
      this.loadData(this.dataProvider, this.options, itemsPerPage, this.numOfPage);
    },
    reload() {
      this.numOfPage = 1;
      const itemsPerPage = parseInt(this.itemsPerPage);
      this.loadData(this.dataProvider, this.options, itemsPerPage, this.numOfPage)
    },
    paginate() {
      if (this.totalItems < 1000) {
        const itemsPerPage = parseInt(this.itemsPerPage)
        const paginateInfo = paginateMatrix(this.data, this.rowPage, this.colPage, itemsPerPage);
        this.rowPage = paginateInfo.rowsPage;
        this.rowPages = paginateInfo.rowsPages;
        this.colPage = paginateInfo.colsPage;
        this.colPages = paginateInfo.colsPages;
        return paginateInfo.data;
      } else {
        return this.data;
      }
    },
    prevRow() {
      if (this.rowPage > 1) {
        this.rowPage -= 1;
      }
    },
    nextRow() {
      if (this.rowPage < this.rowPages) {
        this.rowPage += 1;
      }
    },
    prevCol() {
      if (this.colPage > 1) {
        this.colPage -= 1;
      }
    },
    nextCol() {
      if (this.colPage < this.colPages) {
        this.colPage += 1;
      }
    },
    setNumOfItemsPerPage(value) {
      if (this.totalItems > 1000) {
        this.reload()
      }
      localStorage.setItem(window.location.pathname, value);
    },
    getPivotInternalDataByProp(prop) {
      return this.$refs.pivotTable && this.$refs.pivotTable.internal[prop];
    },
    getPivotInternalDataKeysByProp(prop) {
      return this.getPivotInternalDataByProp(prop).map(i => i.key);
    },
    changeCurrentOperation(operation) {
      this.currentOperation = operation;
      this.emitChangedOptions();
    },
    changeShowSetting(show) {
      this.showSettings = show;
      this.emitChangedOptions();
    },
    changeShowFilterSetting(show) {
      this.showFilterSettings = show;
      this.emitChangedOptions();
    },
    changeShowSQLSettings(show) {
      this.showSQLSettings = show;
      this.emitChangedOptions();
    },
    changeSQLQuery(query) {
      this.sql = query;
      const itemsPerPage = parseInt(this.itemsPerPage)
      this.loadData(this.dataProvider, this.options, itemsPerPage)
    },
    changeHighlightAsHeatmap(highlight) {
      this.highlightAsHeatmap = highlight;
      this.emitChangedOptions();
    },
    changeCurrentCalcColumn(calcColumn) {
      this.currentCalcColumn = calcColumn;
      this.emitChangedOptions();
    },
    changeCurrentConditionGroup(conditionGroup) {
      this.currentConditionGroup = conditionGroup;
      this.emitChangedOptions();
    },
    recalculateLastRow(prevRow, nextRow) {
      prevRow.map((prevItem, prevI) => {
        const prevValue = prevItem.currentValue;
        const prevKey = prevItem.key;
        nextRow.map((nextItem, nextI) => {
          const nextValue = nextItem.currentValue;
          const nextKey = nextItem.key;
          if (prevI === nextI) {
            const recalculate = prevValue + nextValue;
            prevItem.currentValue = recalculate;
            prevItem.value = recalculate.toString();
          }
        })
      })
      return prevRow;
    },
    generateCSVDataset(data) {
      return data.map(arr => {
        let obj = {}
        arr.map(item => {
          obj[item.key] = item.value
        })
        return obj;
      })
    },
    loadData(provider, options, itemsPerPage = 100, numOfPage = 1) {
      const {
        rowFields, colFields, fields, rows, calcColumns, currentCalcColumn, currentOperation, 
        operations, showSettings, showFilterSettings, conditionGroup, highlightAsHeatmap, query, totalItems
      } = getPivot(provider, options, this.dataGrid_options, this.sql, itemsPerPage, numOfPage);

      let data;
      let dataRows = rows === undefined || rows.length === 0 ? [] : rows;

      if (numOfPage !== 1) {
        // recalculate last row totals value
        if(this.data.length !== 0) {
          const lastRow = this.data[this.data.length - 1];
          this.data.splice(-1,1);
          dataRows[dataRows.length - 1] = this.recalculateLastRow(lastRow, dataRows[dataRows.length - 1]);
        }
        data = [...this.data, ...dataRows];
      } else {
        data = dataRows;
      }

      const csvData = this.generateCSVDataset(data);

      this.rowFields = rowFields;
      this.colFields = colFields;
      this.fields = fields;
      this.sql = query;
      this.totalItems = totalItems;
      this.data = data;
      this.csvData = csvData;
      this.calcColumns = calcColumns;
      this.currentCalcColumn = currentCalcColumn;
      this.currentOperation = currentOperation;
      this.operations = operations;
      this.showSettings = showSettings;
      this.showFilterSettings = showFilterSettings;
      this.highlightAsHeatmap = highlightAsHeatmap;
      this.currentConditionGroup = conditionGroup;
    },
    emitChangedOptions() {
      this.$emit('changeOptions', {
        rowFields: this.getPivotInternalDataKeysByProp('rowFields'),
        columnFields: this.getPivotInternalDataKeysByProp('colFields'),
        calcColumn: this.currentCalcColumn,
        operation: this.currentOperation.label,
        showSettings: this.showSettings,
        showSQLSettings: this.showSQLSettings,
        showFilterSettings: this.showFilterSettings,
        conditionGroup: this.currentConditionGroup,
        highlightAsHeatmap: this.highlightAsHeatmap
      });
    }
  }
}

</script>
<style scoped>
    .text-error {
      padding-left: 0 !important;
    }
    .reset {
      position: absolute;
      top: 1px;
      right: 5px;
      font-size: 15px;
      color: #8898aa61;
    }
    .reset:hover {
      color: rgba(39, 39, 53, 0.79);
      cursor: pointer;
    }
    .flex-row-between {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
</style>
